import { useCompanyData, CompanyData } from './use-company-data';

export interface ValidationResult {
  isValid: boolean;
  missingFields: string[];
}

export function useCompanyDataValidation(companyId?: string) {
  const { data: company, isLoading, refetch } = useCompanyData(companyId);

  const validateCompanyData = (data?: CompanyData | null): ValidationResult => {
    if (!data) {
      return {
        isValid: false,
        missingFields: ['email', 'telefone', 'doc_cnpj', 'endereco_logradouro', 'endereco_numero', 'endereco_bairro', 'endereco_cidade', 'endereco_estado', 'endereco_cep']
      };
    }

    const missingFields: string[] = [];
    
    if (!data.email) missingFields.push('email');
    if (!data.telefone) missingFields.push('telefone');
    if (!data.doc_cnpj) missingFields.push('doc_cnpj');
    if (!data.endereco_logradouro) missingFields.push('endereco_logradouro');
    if (!data.endereco_numero) missingFields.push('endereco_numero');
    if (!data.endereco_bairro) missingFields.push('endereco_bairro');
    if (!data.endereco_cidade) missingFields.push('endereco_cidade');
    if (!data.endereco_estado) missingFields.push('endereco_estado');
    if (!data.endereco_cep) missingFields.push('endereco_cep');

    return {
      isValid: missingFields.length === 0,
      missingFields
    };
  };

  const validationResult = validateCompanyData(company);

  return {
    ...validationResult,
    isLoading,
    company,
    refetch
  };
}